<template>
	<!-- 注册 -->
	<div class="content scroll-container">
		<div class="reg-header">
			<img src="../assets/log.png" alt="">
		</div>
		<div class="container">
			<el-form ref="form" :model="form" :rules="rules" label-width="180px">
				<h2>服务商信息检测</h2>
				<div class="check-baseinfo currform">
					<el-form-item label="服务商号">
						<el-input v-model="form.compno"></el-input>
					</el-form-item>
					<el-button type="button" class="reg-button" @click="checkCompno()">点击验证</el-button>
					<el-form-item label="服务商名">
						<el-input v-model="form.compna" disabled></el-input>
					</el-form-item>
				</div>
				<div v-show="hasComp">
					<h2>与服务商关系</h2>
					<div class="entry-info currform">
						<el-radio-group v-model="form.cpcate">
							<el-radio :label="1" @change="changeCpcate">购买服务商所提供的商品或服务</el-radio>
							<el-radio :label="2" @change="changeCpcate">提供商品或服务给服务商</el-radio>
							<el-radio :label="3" @change="changeCpcate">其他与服务商往来的组织或个人</el-radio>
						</el-radio-group>
						<div class="cpcate-select">
							<el-select v-model="form.cpkindr1" placeholder="请选择" v-show="form.cpcate==1">
								<el-option label="标准客户" value="0"></el-option>
								<el-option label="虚拟客户" value="1"></el-option>
								<el-option label="潜在客户" value="2"></el-option>
								<el-option label="办事处" value="3"></el-option>
								<el-option label="专卖店" value="4"></el-option>
								<el-option label="相关公司" value="5"></el-option>
							</el-select>
							<el-select v-model="form.cpkindr2" placeholder="请选择" v-show="form.cpcate==2">
								<el-option label="采购供应商" value="0"></el-option>
								<el-option label="加工供应商" value="1"></el-option>
								<el-option label="运输供应商" value="2"></el-option>
								<el-option label="报关供应商" value="3"></el-option>
							</el-select>
							<el-select v-model="form.cpkindr3" placeholder="请选择" v-show="form.cpcate==3">
								<el-option label="油汽站" value="0"></el-option>
								<el-option label="车商" value="1"></el-option>
								<el-option label="保险公司" value="2"></el-option>
								<el-option label="车管所" value="3"></el-option>
								<el-option label="快递公司" value="4"></el-option>
								<el-option label="货运公司" value="5"></el-option>
								<el-option label="货权方" value="6"></el-option>
								<el-option label="总仓方" value="7"></el-option>
								<el-option label="其它" value="99"></el-option>
							</el-select>
						</div>
					</div>
					<h2>公司或组织信息</h2>
					<div class="entry-info currform">
						<el-form-item label="统一代码" prop="cocode">
							<el-input v-model="form.cocode"></el-input>
						</el-form-item>
						<el-form-item label="公司简称" prop="shortna">
							<el-input v-model="form.shortna"></el-input>
						</el-form-item>
						<el-form-item label="公司全称" prop="fullna">
							<el-input v-model="form.fullna" placeholder="与营业执照一致的信息"></el-input>
						</el-form-item>
						<el-form-item label="英文名称">
							<el-input v-model="form.engna"></el-input>
						</el-form-item>
						<el-form-item label="经济类型" prop="ectype">
							<el-select v-model="form.ectype" placeholder="请选择">
								<el-option label="内资" value="0"></el-option>
								<el-option label="合资" value="1"></el-option>
								<el-option label="独资" value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="结算币别" prop="curno">
							<el-select v-model="form.curno" placeholder="请选择">
								<el-option label="人民币" value="001"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="计税方式" prop="taxmth">
							<el-select v-model="form.taxmth" placeholder="请选择">
								<el-option label="含税" value="0"></el-option>
								<el-option label="未税" value="1"></el-option>
								<el-option label="应税外加" value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="税率(%)" prop="cess">
							<el-input v-model="form.cess"></el-input>
						</el-form-item>
						<el-form-item label="结算日" prop="balday">
							<el-input v-model="form.balday"></el-input>
						</el-form-item>
						<el-form-item label="邮编">
							<el-input v-model="form.zipcode"></el-input>
						</el-form-item>
						<el-form-item label="公司电话" prop="telno">
							<el-input v-model="form.telno"></el-input>
						</el-form-item>
						<el-form-item label="传真">
							<el-input v-model="form.faxno"></el-input>
						</el-form-item>
					</div>
					<h2>注册人信息</h2>
					<div class="entry-info currform">
						<el-form-item label="联系人" prop="linkman">
							<el-input v-model="form.linkman"></el-input>
						</el-form-item>
						<el-form-item label="敬称">
							<el-select v-model="form.desn" placeholder="请选择">
								<el-option label="先生" value="0"></el-option>
								<el-option label="女士" value="1"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="联系电话" prop="linktel">
							<el-input v-model="form.linktel"></el-input>
						</el-form-item>
						<el-form-item label="登录号" prop="logno">
							<el-input v-model="form.logno" maxlength="30"></el-input>
						</el-form-item>
						<el-form-item label="初始密码" prop="pwd">
							<el-input v-model="form.pwd"></el-input>
						</el-form-item>
						<el-form-item label="Email" prop="email">
							<el-input v-model="form.email"></el-input>
						</el-form-item>
						<el-form-item label="QQ">
							<el-input v-model="form.qqno"></el-input>
						</el-form-item>
						<el-form-item label="所在部门">
							<el-input v-model="form.branna"></el-input>
						</el-form-item>
						<el-form-item label="职务">
							<el-input v-model="form.jobna"></el-input>
						</el-form-item>
					</div>
					<h2>注册人信息验证</h2>
					<div class="entry-info currform">
						<el-form-item label="注册手机" prop="regtel">
							<el-input v-model="form.regtel"></el-input>
						</el-form-item>
						<el-button type="button" class="reg-button" @click="getCode()">获取验证码</el-button>
						<el-form-item label="验证码" prop="postcode">
							<el-input v-model="form.postcode" maxlength="6"></el-input>
						</el-form-item>
					</div>
					<el-button type="primary" @click="submitAccount('form')">开户</el-button>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return {
				hasComp: false, 
				form:{
					compno: '',
					compna: '',
					cpcate: 1,
				},
				rules: {
					cocode: [
						{ required: true, message: '请输入公司代码', trigger: 'blur' }
					],
					shortna: [
						{ required: true, message: '请输入公司简称', trigger: 'blur' }
					],
					ectype: [
						{ required: true, message: '请选择经济类型', trigger: 'blur' }
					],
					curno: [
						{ required: true, message: '请选择结算币别', trigger: 'blur' }
					],
					taxmth: [
						{ required: true, message: '请选择计税方式', trigger: 'blur' }
					],
					cess: [
						{ required: true, message: '请输入税率', trigger: 'blur' }
					],
					balday: [
						{ required: true, message: '请输入结算日', trigger: 'blur' }
					],
					telno: [
						{ required: true, message: '请输入公司电话', trigger: 'blur' }
					],
					linkman: [
						{ required: true, message: '请输入联系人', trigger: 'blur' }
					],
					linktel: [
						{ required: true, message: '请输入联系电话', trigger: 'blur' }
					],
					logno: [
						{ required: true, message: '请输入登录号', trigger: 'blur' }
					],
					pwd: [
						{ required: true, message: '请输入初始密码', trigger: 'blur' }
					],
					email: [
						{ required: true, message: '请输入Email', trigger: 'blur' }
					],
					regtel: [
						{ required: true, message: '请输入注册手机', trigger: 'blur' }
					],
					postcode: [
						{ required: true, message: '请输入验证码', trigger: 'blur' }
					],
				}
			}
		},
		created() {
			let _this = this;
			
		},
		mounted() {
			
		},
		methods: {
			// 开户
			submitAccount(form) {
				console.log(JSON.stringify(this.form));
				this.$refs[form].validate((valid) => {
					if (valid) {
						alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			
			
			// 检测compno是否存在
			checkCompno() {
				let _this = this; 
				let compData = {compno:_this.form.compno};
				console.info(compData)
				// this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading' });
				_this.$axios.post('upus_APP/app/employee/compcheck', compData).then(function(result) {
				  console.info(result.data)
				  let res = result.data;
				  // _this.$toast.clear(); //
				  if(res.success == 0) {
						_this.hasComp = false;
				    _this.form.compna = '';
				    return _this.$message({ message:res.msg, type:'warning', offset:'200' });
				  } else {
						_this.hasComp = true;
				    _this.form.compna = res.data;
						console.info(JSON.stringify(_this.form))
				  }
				})
				.catch(function(error) {
					console.info(error)
				  // return _this.$message('error');
				})
			},
			changeCpcate(val) {
				console.info('cpkindr'+val)
				let cate1 = 'cpkindr'+val
			  console.info(this.form.cate1)
				// let cpcate1 = 'cpkindr'+val;
				// this.form.cpkindr = this.form['cpkindr'+val];
			}
		}
	}
</script>

<style scoped>
	.reg-header{
		width: 100%;
		height: 70px;
		background: #fff;
		box-shadow:0px 1px 5px #999;
		text-align: center;
	}
	.reg-header img{
		width: 140px;
		height: 70px;
	}
	.el-form{
		padding-bottom: 200px;
	}
	h2{
		padding: 10px 0px;
		font-weight: 100;
		color: #0391d5;
		border-bottom: 1px solid #0391d5;
	}
	.reg-button{    
    height: 35px;
    padding: 0px 20px;
    margin:0px 0px 20px 180px;
	}
	.currform{
		padding: 0px 10%;
	}
	.cpcate-radio{
		margin-bottom: 15px;
	}
	.cpcate-select{
		margin-top: 20px;
	}
	
	@media screen and (max-width: 768px) {
		.container{
			margin: 12px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/register.vue